// The Joulelingo character's moods: which face, arms, extra and movement each one wears.
// Source: the design board "Gamey Joulelingo: look, character and screens" (Poses), concept A,
// the speech-bolt buddy chosen on 27 Oct. Plain data so it can be tested without a DOM.
//
// It cheers pupils on and never scolds them, so there is no angry or disappointed mood: a
// wrong answer gets 'happy' with kind words, and 'worried' is kept for a spike nobody expected.

export const MOODS = {
    // Home screen, a right answer.
    happy: {
        eyes: 'open',
        mouth: 'smile',
        arms: 'rest',
        extra: null,
        motion: 'bob'
    },
    // Quiz finished, a house wins the week.
    celebrating: {
        eyes: 'happy',
        mouth: 'open',
        arms: 'up',
        extra: 'confetti',
        motion: 'jump'
    },
    // While a question is open.
    thinking: {
        eyes: 'up',
        mouth: 'hmm',
        arms: 'chin',
        extra: 'question',
        motion: 'tilt'
    },
    // Holidays, overnight, weekends.
    sleepy: {
        eyes: 'sleep',
        mouth: 'o',
        arms: 'hug',
        extra: 'zzz',
        motion: 'breathe'
    },
    // A spike nobody expected.
    worried: {
        eyes: 'worried',
        mouth: 'wobble',
        arms: 'rest',
        extra: 'sweat',
        motion: 'wiggle'
    },
    // Welcome, empty states, sign-in.
    waving: {
        eyes: 'open',
        mouth: 'smile',
        arms: 'wave',
        extra: null,
        motion: 'bob'
    }
}

// The character's name, chosen by Ross on 27 Oct: short, energetic, easy to shout.
export const CHARACTER_NAME = 'Jolt'

export const DEFAULT_MOOD = 'happy'

/** The look for a mood; anything unknown gets the default, never a blank character. */
export const moodLook = (mood) => MOODS[mood] || MOODS[DEFAULT_MOOD]
